import script from "./CartaoPdf.vue?vue&type=script&setup=true&lang=ts"
export * from "./CartaoPdf.vue?vue&type=script&setup=true&lang=ts"

import "./CartaoPdf.vue?vue&type=style&index=0&id=fb8830ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb8830ca"]])

export default __exports__